export enum EEntreeProcessType {
    IntZoneTraitement = 1,
    SAS,
    ExtZoneTraitement,
    ExtPerimetreChantier,
    ExtSASUMD
}